
import React from 'react'
import { Input } from 'antd'

const DefaultColumnFilter = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    refInput
}) => {

    return (
        <Input
            placeholder="Buscar"
            ref={(node) => {
                refInput.current = node;
            }}
            autoFocus={true}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => {
                confirm();
            }}
            style={{ width: 200, marginBottom: 10, display: 'block' }}
        />
    )
}
export default DefaultColumnFilter;

